import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/* eslint-disable */

export type ImpersonationContext = {
  assumed: boolean;
  cid?: string;
  customerName?: string;
  startedAt?: string;
};

const STORAGE_KEY = 'nio.impersonation';

@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private readonly _ctx$ = new BehaviorSubject<ImpersonationContext>(
    this.read()
  );
  ctx$ = this._ctx$.asObservable();

  get ctx() {
    return this._ctx$.value;
  }
  get isImpersonating() {
    return !!this.ctx.assumed && !!this.ctx.cid;
  }
  get effectiveCid() {
    return this.ctx.cid;
  }

  /** Start impersonation and refresh the page */
  assume(cid: string, customerName?: string) {
    const ctx: ImpersonationContext = {
      assumed: true,
      cid,
      customerName,
      startedAt: new Date().toISOString(),
    };
    this.write(ctx);
    this.refreshPage();
  }

  /** Stop impersonation and refresh the page */
  release() {
    this.write({ assumed: false });
    this.refreshPage();
  }

  private write(ctx: ImpersonationContext) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ctx));
    this._ctx$.next(ctx);
  }

  /** Hard refresh so subsequent API calls use the updated impersonation headers */
  private refreshPage() {
    // allow storage + subscribers to flush before reload
    setTimeout(() => window.location.reload(), 0);
  }

  private read(): ImpersonationContext {
    try {
      return (
        JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}') || {
          assumed: false,
        }
      );
    } catch {
      return { assumed: false };
    }
  }
}
